import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

// const timeFormat = (utcDate: string): string => {
//     let options = {
//         // era: 'long',
//         year: 'numeric',
//         month: 'numeric',
//         day: 'numeric',
//         // weekday: 'long',
//         // timezone: 'UTC',
//         hour: 'numeric',
//         minute: 'numeric',
//         second: 'numeric',
//     };
//     const date = new Date(utcDate);
//     return date.toLocaleString('en-US', options);
// };

// This is a workaround for converting UTC+8 timestamp to Jakarta time
// as the default time zone of DB is UTC+8.
// Need to change back the above function when the DB time zone is changed to UTC.
const timeFormat = (
    dateTime: string,
    overrideTime: boolean = false,
): string => {
    if (overrideTime) {
        const utcDate = dayjs(dateTime).subtract(8, 'hour').toString();
        return dayjs(utcDate).tz('Asia/Jakarta').format('M/D/YYYY, h:mm:ss A');
    } else {
        return dayjs.utc(dateTime).tz('Asia/Jakarta').format('M/D/YYYY, h:mm:ss A');
    }
};

export default timeFormat;
